import { useState } from "react";
import { useWorkflows } from "../hooks/useWorkflows";
import { WorkflowCard } from "./WorkflowCard";
import { WorkflowRunHistory } from "./WorkflowRunHistory";

export function WorkflowsPage() {
  const { workflows, loading, toggle, remove, getRuns } = useWorkflows();
  const [selectedId, setSelectedId] = useState<string | null>(null);

  if (loading) {
    return (
      <div className="flex flex-1 items-center justify-center text-gray-400">
        Loading workflows...
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-2xl p-6">
      <h2 className="mb-4 text-lg font-semibold text-gray-900">Workflows</h2>
      {workflows.length === 0 ? (
        <p className="text-sm text-gray-500">
          No workflows yet. Create one by chatting with Deft — try "create a
          daily morning briefing of my calendar events".
        </p>
      ) : (
        <div className="space-y-3">
          {workflows.map((w) => (
            <div key={w.id}>
              <WorkflowCard
                workflow={w}
                onToggle={toggle}
                onDelete={remove}
                onSelect={setSelectedId}
              />
              {selectedId === w.id && (
                <WorkflowRunHistory workflowId={w.id} getRuns={getRuns} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
